<template>
    <header class="ro-header">
        <div class="ro-header__inner">

            <!-- LOGO -->
            <router-link to="/" class="ro-header__logo">
                <img :src="randomImage" alt="Logo" class="logo" />
            </router-link>
            <v-spacer></v-spacer>
            <!-- NAV LINKS -->
            <nav class="ro-header__nav">
                <div
                    v-for="link in filteredLinks"
                    :key="link.id"
                    class="ro-header__nav-item"
                    :class="{ 'has-children': link.children && link.children.length }"
                    @mouseenter="openSubmenu(link.id)"
                    @mouseleave="closeSubmenu(link.id)"
                >
                    <router-link
                        v-if="!link.children || !link.children.length"
                        :to="link.route"
                        class="ro-header__nav-link"
                        active-class="is-active"
                        @click.native="goAction(link.action)"
                    >
                        {{ $t(link.titleKey) }}
                    </router-link>

                    <span
                        v-else
                        class="ro-header__nav-link"
                        :class="{ 'is-active': openId === link.id }"
                        @click="toggleSubmenu(link.id)"
                    >
                        {{ $t(link.titleKey) }}
                    </span>

                    <!-- SUBMENU -->
                    <transition name="fade">
                        <div
                            v-if="link.children && link.children.length && openId === link.id"
                            class="ro-header__submenu"
                        >
                            <router-link
                                v-for="child in link.children"
                                :key="child.id"
                                :to="child.route"
                                class="ro-header__submenu-link"
                                @click.native="goAction(child.action)"
                            >
                                {{ $t(child.titleKey) }}
                            </router-link>
                        </div>
                    </transition>
                </div>
            </nav>

            <!-- RIGHT SIDE: LANGUAGE + AUTH BUTTONS -->
            <div class="ro-header__right">

                <div class="ro-header__stats">
                    <div class="ro-header__stat">
                        <span class="ro-header__stat-label">{{ $t('header.stats.online') }}</span>
                        <span class="ro-header__stat-value ro-header__stat-value--online">{{ onlinePlayers }}</span>
                    </div>
                    <div class="ro-header__stat">
                        <span class="ro-header__stat-label">{{ $t('header.stats.peak') }}</span>
                        <span class="ro-header__stat-value ro-header__stat-value--peak">{{ onlinePeak }}</span>
                    </div>
                </div>

                <v-divider vertical class="ro-header__stats-divider"></v-divider>

                <v-menu offset-y content-class="ro-header__lang-menu">
                    <template v-slot:activator="{ on, attrs }">
                        <div class="ro-header__lang" v-bind="attrs" v-on="on">
                            <span :class="`flag-icon flag-icon-${currentLanguage.flag}`"></span>
                            <v-icon size="18" color="white">mdi-chevron-down</v-icon>
                        </div>
                    </template>
                    <v-list dense>
                        <v-list-item
                            v-for="lang in languages"
                            :key="lang.code"
                            @click="changeLanguage(lang.code)"
                        >
                            <v-list-item-avatar size="20">
                                <span :class="`flag-icon flag-icon-${lang.flag}`"></span>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>{{ lang.name }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>

                <MenuProfile
                    v-if="account_id > 0"
                    :account_id="account_id"
                    :group_id="group_id"
                    :currentLocale="currentLocale"
                    :reference="reference"
                    :user_name="user_name"
                    :credit="credit"
                    @logout="goEmit('logout')"
                />
                <template v-else>
                    <button class="ro-header__btn ro-header__btn--login" @click="goEmit('open_login')">
                        {{ $t('header.login') }}
                    </button>
                    <button class="ro-header__btn ro-header__btn--register" @click="goEmit('open_register')">
                        {{ $t('header.register') }}
                    </button>
                </template>

            </div>
        </div>
    </header>
</template>

<script>
import Vue from "vue";
import axios from 'axios';
import MenuProfile from "@/components/CompNavBarMenuProfile.vue";
export default {
  name: 'AppNavBar',
  components: {
    MenuProfile,
  },
  props:[
      'account_id',
      'group_id',
      'currentLocale',
      'reference',
      'user_name',
      'credit',
    ],
  data: () => ({
    name: 'Welcome',
	showlogin: true,
    email: '',
    status: false,
    drawer: true,
    mini: true,
    isLoading: false,
    model: null,
    search: '',
    showLoginDialog: false,
    showDialogManager: false,
    showDialogAnnounce: false,
    items_search: [],
    categorias:  [],
    openId: null,
    onlinePlayers: 0,
    onlinePeak: 0,


    links_headers: [
		{  id: 1, need_login: 0, titleKey: 'header.nav.home', action: 'home', route: '/' },
		{  id: 2, need_login: 0, titleKey: 'header.nav.download',  action: 'download', route: '/downloads' },
		{  id: 3, need_login: 0, titleKey: 'header.nav.shop',  action: 'shop', route: '/shop' },
		{  id: 4, need_login: 0, titleKey: 'header.nav.information',  action: 'information', route: '/serverinfo',
			children: [
				{ id: 41, need_login: 0, titleKey: 'header.nav.wiki', action: 'wiki', route: '/wiki' },
				{ id: 42, need_login: 0, titleKey: 'header.nav.bosscards', action: 'bosscards', route: '/bosscards' },
				{ id: 43, need_login: 0, titleKey: 'header.nav.vendors', action: 'vendors', route: '/vendors' },
				{ id: 44, need_login: 0, titleKey: 'header.nav.rules', action: 'rules', route: '/rules' },
			]
		},
		{  id: 5, need_login: 0, titleKey: 'header.nav.rankings',  action: 'ranking', route: '/ranking' },
		{  id: 6, need_login: 0, titleKey: 'header.nav.vote',  action: 'vote', route: '/vote' },
  	],
	locales: ['en', 'es'],
	languages: [
		{ code: 'en', name: 'English', flag: 'us' },
        { code: 'es', name: 'Español', flag: 'es' },
        { code: 'pt', name: 'Português', flag: 'pt' },
        { code: 'fil', name: 'Filipino', flag: 'ph' },
      ],
	  images: [
        "/assets/imgs/logo/logo_01.png",
        "/assets/imgs/logo/logo_01.png"
      ],
      randomImage: "",
  }),
  mounted() {
	this.randomImage = this.images[Math.floor(Math.random() * this.images.length)];
    },


  methods: {
	changeLanguage(lang) {
        this.$emit('emit_changeLanguage',lang);
    },
	goAction(action) {
        this.$emit('emit_action',action);
    },
	toggleSubmenu(id) {
		this.openId = this.openId === id ? null : id;
	},
	openSubmenu(id) {
		this.openId = id;
	},
	closeSubmenu(id) {
		if (this.openId === id) this.openId = null;
	},
    goEmit(val){
        console.log(val);
        this.$emit(val);
    }
  },
  computed: {
    currentLanguage() {
      return this.languages.find(lang => lang.code === this.$i18n.locale) || this.languages[0];
    },
	filteredLinks() {
		return this.links_headers.filter(link => {
		return link.need_login === 0 || (link.need_login === 1 && this.account_id > 0);
		});
	}
  },
};
</script>

<style scoped>
.ro-header {
    width: 100%;
    background: linear-gradient(180deg, var(--rmx-navy-900) 0%, var(--rmx-navy-950) 100%);
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.5);
    border-bottom: 1px solid rgba(217, 172, 92, 0.35);
    position: relative;
    z-index: 100;
}

.ro-header__inner {
    width: 100%;
    max-width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    padding: 0 24px;
    box-sizing: border-box;
}

/* LOGO */
.ro-header__logo {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    margin-right: 40px;
}

.ro-header__logo .logo {
    height: 46px;
    object-fit: contain;
}

/* NAV */
.ro-header__nav {
    display: flex;
    align-items: center;
    flex: 1 1 auto;
    height: 100%;
}

.ro-header__nav-item {
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
}

.ro-header__nav-link {
    font-family: 'Oswald', 'Arial Narrow', Arial, sans-serif;
    font-weight: 600;
    font-size: 13px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: var(--rmx-text-muted, #8a97ad);
    text-decoration: none;
    padding: 0 18px;
    height: 100%;
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: color 0.2s ease;
    border-bottom: 2px solid transparent;
}

.ro-header__nav-link:hover,
.ro-header__nav-link.is-active {
    color: #ffffff;
    border-bottom-color: var(--rmx-gold, #d9ac5c);
}

/* SUBMENU */
.ro-header__submenu {
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    min-width: 160px;
    background: var(--rmx-navy-800, #101c33);
    border: 1px solid rgba(217, 172, 92, 0.3);
    border-top: 2px solid var(--rmx-gold, #d9ac5c);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.55);
    display: flex;
    flex-direction: column;
    padding: 8px 0;
}

.ro-header__submenu-link {
    font-family: 'Oswald', 'Arial Narrow', Arial, sans-serif;
    font-weight: 600;
    font-size: 12px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: #ffffff;
    text-decoration: none;
    text-align: center;
    padding: 12px 16px;
    transition: background 0.2s ease, color 0.2s ease;
}

.ro-header__submenu-link:hover {
    background: rgba(217, 172, 92, 0.12);
    color: var(--rmx-gold-bright, #f0c878);
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.15s ease;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}

/* RIGHT SIDE */
.ro-header__right {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    gap: 16px;
    margin-left: 24px;
}


.ro-header__stats {
    display: flex;
    align-items: center;
    gap: 20px;
}
 
.ro-header__stat {
    display: flex;
    flex-direction: column;
    align-items: center;
    line-height: 1.2;
}
 
.ro-header__stat-label {
    font-family: 'Oswald', 'Arial Narrow', Arial, sans-serif;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: var(--rmx-text-muted, #8a97ad);
}
 
.ro-header__stat-value {
    font-family: 'Oswald', 'Arial Narrow', Arial, sans-serif;
    font-size: 15px;
    font-weight: 700;
    color: var(--rmx-text, #eaf0fb);
}

.ro-header__stat-value--online {
    color: var(--rmx-blue-bright, #6ea0ff);
}

.ro-header__stat-value--peak {
    color: var(--rmx-gold-bright, #f0c878);
}
 
.ro-header__stats-divider {
    height: 30px;
    margin: 0 4px;
    border-color: rgba(217, 172, 92, 0.25) !important;
}


.ro-header__lang {
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    padding: 6px;
}

.ro-header__lang .flag-icon {
    border-radius: 2px;
}

.ro-header__btn {
    font-family: 'Oswald', 'Arial Narrow', Arial, sans-serif;
    font-weight: 600;
    font-size: 13px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    border: none;
    cursor: pointer;
    padding: 10px 22px;
    border-radius: 3px;
    transition: filter 0.2s ease;
}

.ro-header__btn:hover {
    filter: brightness(1.12);
}

.ro-header__btn--login {
    background: var(--rmx-navy-800, #101c33);
    color: #ffffff;
    border: 1px solid rgba(217, 172, 92, 0.4);
}

.ro-header__btn--register {
    background: linear-gradient(135deg, var(--rmx-gold-bright, #f0c878), var(--rmx-gold, #d9ac5c));
    color: var(--rmx-navy-950, #060b18);
    box-shadow: 0 0 14px rgba(217, 172, 92, 0.35);
}

/* RESPONSIVE */
@media (max-width: 960px) {
    .ro-header__nav {
        display: none;
    }
}
</style>